import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'Confirm',
    description: 'Does your company operate outside the European Union?',
    descriptionMandatee:
      'Will your client’s company operate outside the European Union?',
    no: 'No',
    title: 'About {legalName}:',
    titleNoLegalName: 'About your company:',
    yes: 'Yes',
  },
  fr: {
    cta: 'Confirmer',
    description:
      'Votre entreprise opèrera-t-elle en dehors de l’Union Européenne\u00A0?',
    descriptionMandatee:
      'L’entreprise de votre client•e opèrera-t-elle en dehors de l’Union Européenne\u00A0?',
    no: 'Non',
    title: 'À propos de {legalName} :',
    titleNoLegalName: 'À propos de votre entreprise :',
    yes: 'Oui',
  },
} as const);
